<template>
  <div class="feedback">
    <!-- <Header title="我的反馈记录" background="white" /> -->
    <simple-scroll-list v-model="loading" :finished="finished" @load="onLoad">
      <div class="list-item" v-for="item in list" :key="item.id">
        <div class="item-header">
          <p>{{ item.title }}</p>
          <div class="row-line"></div>
          <p>{{ item.createdAt }}</p>
        </div>
        <div class="message">
          {{ item.content }}
        </div>
        <div class="reply" v-if="item.reply">
          <img src="../../../assets/my/Bitmap@2x.png" alt="" class="avatar" />
          <div class="reply-message">
            {{ item.reply }}
          </div>
        </div>
      </div>
    </simple-scroll-list>
  </div>
</template>

<script type="text/ecmascript-6">
import SimpleScrollList from "../../../components/SimpleScrollList.vue";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      form: {
        lastId: 0,
        page: 1,
      },
    };
  },
  methods: {
    onLoad() {
      this.$post({
        module: "Content",
        interface: "5000",
        data: this.form,
      }).then((res) => {
        // console.log("反馈列表", res);
        this.form.page++;
        this.form.lastId = res.lastId;
        this.list = this.list.concat(res.list);
        if (res.lastPage == res.currentPage) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
  },
  components: { SimpleScrollList },
};
</script>

<style scoped lang="less">
.feedback {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fbfbfb;

  .simple-scroll-list {
    flex: 1;
    padding: 15px 16px;

    .list-item {
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(96, 98, 102, 0.08);
      border-radius: 8px;
      padding: 14px 12px;
      margin-bottom: 16px;

      .item-header {
        font-size: 13px;
        color: #999999;
        display: flex;
        align-items: center;
        margin-bottom: 11px;
        width: 100%;
        word-break: break-all;
        flex-wrap: wrap;
        line-height: 20px;

        .row-line {
          height: 12px;
          background-color: #cccccc;
          width: 1px;
          margin: 0 8px;
        }
      }

      .message {
        font-size: 15px;
        color: #333333;
        margin-bottom: 16px;
      }

      .reply {
        display: flex;
        align-items: flex-start;

        .avatar {
          width: 36px;
          height: 36px;
          margin-right: 17px;
        }

        .reply-message {
          flex: 1;
          background: #fff8f8;
          border-radius: 4px;
          padding: 12px;
          padding-right: 6px;
          font-size: 15px;
          color: #fd0212;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>